/* eslint-disable react/no-children-prop */
import React from 'react';
import { PropTypes } from 'prop-types';
import Button from 'shared/ui/Button';
import CancelButton from 'shared/ui/CancelButton';
import {
  Wrapper, WrapperTitle, Title, Footer, Message
} from './styled';
import useKeyPress from 'Hooks/useKeyPress';

const Modal = ({
  title, icon, children, onAccept, onClose, acceptLabel, closeLabel
}) => {
  useKeyPress(() => {
    if (onAccept) onAccept();
  }, ['Enter']);

  useKeyPress(() => {
    if (onClose) onClose();
  }, ['Escape']);

  return (
    <Wrapper>
      <WrapperTitle show={ icon || title }>
        {icon}
        <Title children={ title } />
      </WrapperTitle>
      <Message children={ children } />
      <Footer show={ onClose || onAccept }>
        { onClose && <CancelButton onClick={ onClose } children={ closeLabel } /> }
        { onAccept && <Button onClick={ onAccept } children={ acceptLabel } /> }
      </Footer>
    </Wrapper>
  );
};

Modal.propTypes = {
  acceptLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  title: PropTypes.string
};

Modal.defaultProps = {
  acceptLabel: 'Accept',
  closeLabel: 'Close',
  title: ''
};

export default Modal;
